import { getCountryOrContinentFromLocationList } from '@/domain/location/useCases/getCountryOrContinentFromLocationList'
import { getLocationPartsTitles } from '@/domain/location/useCases/getLocationPartsTitles'
import { Center } from '@/types/models'
import { Location } from '@/types/models/Location.model'
import { fetchFeaturedCenters } from '@/repository/center/fetchFeaturedCenter'
import { PrimaryFocus } from '@/domain/primaryFocus/constant'

const HITS_PER_PAGE = 15

export const getFeaturedCenters = async ({
  locationData,
  allCountries,
  hitsPerPage = HITS_PER_PAGE,
  primaryFocus,
  termData
}: {
  locationData: Location
  allCountries: { node: Location }[]
  hitsPerPage: number
  primaryFocus?: PrimaryFocus
  termData?: { type: string; title: string }
}): Promise<Center[]> => {
  const allCountriesTitles = allCountries.map(({ node }) => node.title)

  const location = getCountryOrContinentFromLocationList(
    getLocationPartsTitles(locationData),
    allCountriesTitles
  )

  return await fetchFeaturedCenters({
    location,
    hitsPerPage,
    primaryFocus,
    termData
  })
}
